import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import EstimationSimulator from "../components/EstimationSimulator";
import EstimationGuide from "../components/EstimationGuide";
import { Toaster } from "../components/ui/toaster";

export default function Estimation() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F4F0E9]">
      <Header />
      <main>
        <EstimationSimulator />
        <EstimationGuide />
        <Footer />
      </main>
      <Toaster />
    </div>
  );
}
